import { useQuery } from '@tanstack/react-query'

import { DEFAULT_STALE_TIME } from '~/constants'
import { TAgentChatbot } from '~/features/agents/models'
import { queryKeys } from '~/features/agents/utils'
import { EServerPath } from '~/models/api'
import HttpService from '~/services/http'

const useGetChatbotSettings = (agentId: string) => {
  return useQuery({
    queryKey: queryKeys.chatbotSettings(agentId),
    queryFn: () =>
      HttpService.get<TAgentChatbot | null>({
        path: EServerPath.chatbotSettings,
        query: { agentId },
      }),
    enabled: !!agentId,
    staleTime: DEFAULT_STALE_TIME,
  })
}

export default useGetChatbotSettings
